import { render, staticRenderFns } from "./ItemTextInfo.vue?vue&type=template&id=2dfd40a0&"
import script from "./ItemTextInfo.vue?vue&type=script&lang=js&"
export * from "./ItemTextInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports